import i18n from 'i18next';
import { useStores } from './core/stores/rootStore';
import moment from 'moment';
import { useRef, useEffect, useState, useCallback, useLayoutEffect} from 'react';
import { observer } from "mobx-react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { toJS } from "mobx"
import { Box, IconButton, Tooltip as MuiTooltip/*, EditIcon,DeleteIcon*/ } from '@mui/material';

Array.prototype.sortByDate = function () {
        return this?.sort((a, b) => a.getTime() - b.getTime());
}

export const allowedExtensions = ".jpeg,.jpg,.png,.pdf";
export const isImage = (filename) => [".jpeg", ".jpg", ".png"].some(ext => filename?.toLowerCase()?.endsWith(ext));
export const isPDF = (filename) => filename?.toLowerCase()?.endsWith(".pdf");

export const removeTimestampFromFilename = (filename) => {    
    var ext = filename?.split(".").slice(-1);
    var name = filename?.substring(0, filename.length - 23);
    return `${name}.${ext}`;
}

export const isInRange = (activity, month, year) => {        
    var start = new Date(activity.startYear, activity.startMonth-1);
    var end = !activity.endYear || !activity.endMonth ? new Date(8640000000000000) : new Date(activity.endYear, activity.endMonth -1);
    var period = new Date(year, month-1);
    var inRange = start <= period && period <= end;    

    return inRange;    
}

export const sort = (prop, arr)=> {
    prop = prop.split('.');
    var len = prop.length;

    arr.sort(function (a, b) {
        var i = 0;
        while (i < len) { a = a[prop[i]]; b = b[prop[i]]; i++; }
        if (a < b) {
            return -1;
        } else if (a > b) {
            return 1;
        } else {
            return 0;
        }
    });
    return arr;
};

export const truncateString=(str, maxLength)=> {
    if (str?.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
    }
    return str;
}

export const lpad=(value, padding) =>{
    var zeroes = new Array(padding + 1).join("0");
    return (zeroes + value).slice(-padding);
}

export const forceTwoDigits = (myNumber) => {
    return Number(myNumber).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })
}

export const numericKeydown = (e,clearFn) => {    
    if (e.key == "Backspace" || e.key == "Delete") { clearFn?.(); }
    else if (e.key === "Tab" || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 109 || e.keyCode === 35 || e.keyCode === 36 || e.keyCode === 37 || e.keyCode === 39) { }
    else {
        var isNumber = (e.key < 48 || e.key > 57)
        if (e.key === "ArrowDown" || e.key === "ArrowUp" || !isNumber) { e.preventDefault(); e.stopPropagation() }
    }
}
export const isNumber2Decimals = (evt) => {
    //console.log(evt)
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
        return false;
    else {
        var value = evt.target.value;
        var len = value.length;
        var index = value.indexOf('.');
        if (index > 0 && charCode == 46) {
            return false;
        }
        
        if (index > 0) {
            var CharAfterdot = (len + 1) - index;            
            if (CharAfterdot > 3) {                
                evt.preventDefault();
                return false;
            }
        }

    }
    return true;
}

export const isZeroOne = (evt) => {    
    var charCode = (evt.which) ? evt.which : evt.keyCode;    
    if ((charCode === 48 || charCode === 49)) {        
        //if (Number(evt.target.value?.toString()?.length ?? 0) + 1 > 1)
        //    evt.preventDefault();
        //else
            return true;
    } else {
        evt.preventDefault();
    }
}

export const isNumberKey = (evt) => {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    
    if (charCode > 47 && charCode < 58) {
        return true;
    } else {
        evt.preventDefault();
    }
}

export const getLocalizedCountryFromCurrency = (currency) => {
    if (currency == null)
        return "";

    var value = currency.countryEN;
    switch (i18n.language) {
        case "fr":
            value = currency.countryFR;
            break;
        case "en":
            value = currency.countryEN;
            break;
        default:
            value = currency.countryEN;
            break;
    }
    return value;
}

export const isJsonString = (str) => {
    try {JSON.parse(str);} catch (e) {return false;}
    return true;
}

export const setConfig = (entity, property, value) => {
    //localStorage.setItem(`${entity}_${property}`, JSON.stringify(value));
    setLocalStorage(`${entity}_${property}`, value);
}

export const getConfig = (entity,property) => {
    /*var sizes = localStorage.getItem(`${entity}_${property}`);    
    return  sizes ? JSON.parse(sizes) : null;    */
    return getFromLocalStorage(`${entity}_${property}`);
}
export const getFromLocalStorage = (property, defaultVal) => {
    var prop = localStorage.getItem(`${property}`);
    //console.log(JSON.parse(prop))
    return prop && isJsonString(prop) ? JSON.parse(prop) : (defaultVal ?? null);
}
export const setLocalStorage = (property, value) => {
    localStorage.setItem(`${property}`, JSON.stringify(value));    
}

export const isEditableForMonth = (activity, month, year,role) => [2, 3].indexOf((role)) > -1 && [0, 2].indexOf(getMonthForActivity(activity, month, year)?.status ?? 0) > -1 || (role == 1 && getMonthForActivity(activity, month, year)?.status == 3) || (role == 1 && activity.confidential && getMonthForActivity(activity, month, year)?.status == null);
export const getMonthForActivity = (activity, month, year) => activity?.months.find(m => m.month == month + 1 && m.year == year);

export const stringToDate = (x) => new Date(x.split("-")[0], x.split("-")[1] - 1, 1);

export const getAvailableMonths2 = (list, role) => {        
    var startDates = [...new Set(list?.map(x => x.startDate))]?.map(x => stringToDate(x))?.sortByDate();
    var endDates = [...new Set(list?.map(x => x.endDate))]?.map(x => stringToDate(x))?.sortByDate();
    var minStart = startDates?.[0];
    var maxEnd = endDates?.[endDates.length - 1];

    var found = [];
    if (role == 3) {
        for (var d = minStart; d <= maxEnd; d.setMonth(d.getMonth() + 1)) {
            list.map(x => toJS(x)).map((a) => {
                var min = new Date(a.startYear, a.startMonth - 1, 1);
                var max = new Date(a.endYear, a.endMonth, 0);
                var monthEditable = isEditableForMonth(a, d.getMonth(), d.getFullYear(),role);

                if ((d <= max && d >= min) && monthEditable) {
                    found.push(new Date(d));
                }

            });
        }
    }
    else if (role == 2) {
        var toValidate = (list ?? [])?.flatMap(x => x.months)?.filter(x => x.status == 1)?.map(x => new Date(x.year, x.month - 1, 1))?.sortByDate();
        
        toValidate?.forEach((v) => found.push(v))
    }
    return found;
}

export const getUserTypes = () => {
    return [
        { id: 1, name: i18n.t('admin'), key: "admin" },
        { id: 2, name: i18n.t('client'), key: "client" },
        { id: 3, name: i18n.t('consultant'), key: "consultant" }];
}

export const getExpenseStatus = () => {
    return [
        { id: 0, name: i18n.t('pendingConsultant'), key: "pendingConsultant" },
        { id: 1, name: i18n.t('pendingValidation'), key: "pendingValidation" },
        { id: 2, name: i18n.t('validated'), key: "validated" },
        { id: 3, name: i18n.t('rejected'), key: "rejected" }];
}

export const getTimesheetActivityFilter = () => {
    return [
        { id: 0, name: i18n.t('all'), key: "all" },
        { id: 1, name: i18n.t('pendingConsultant'), key: "pendingConsultant" },
        { id: 2, name: i18n.t('pendingValidationClient'), key: "pendingValidationClient" },
        { id: 3, name: i18n.t('rejected'), key: "rejected" },
        { id: 4, name: i18n.t('validatedByClient'), key: "validatedByClient" },
        { id: 5, name: i18n.t('validated'), key: "validated" },
        { id: 6, name: i18n.t('billed'), key: "billed" }];
}

export const getPackageTypes = () => {
    return [
        { id: 0, name: i18n.t("telephoneIT"), key:"telephoneIT" },
        { id: 1, name: i18n.t("km"), key:"km" },
        { id: 2, name: i18n.t("breakfast"), key:"breakfast" },
        { id: 3, name: i18n.t("lunch") ,key:"lunch"},
        { id: 4, name: i18n.t("dinner"),key:"dinner"},
        { id: 5, name: i18n.t("lodging"),key:"lodging"},
        /*{ id: 2, name: i18n.t("unit"), },
        { id: 3, name: i18n.t("currencyAmount"), }*/
    ];
}

export const getLanguages = () => {
    return [{ id: "fr", name: i18n.t('french'), key: "french" }, { id: "en", name: i18n.t('english'), key: "english" }];
}

export const getYesNoOptions = (locale) => [{ text: i18n.t("no", { lng: locale ?? i18n.language }), value: "0" }, { text: i18n.t("yes",{ lng: locale ?? i18n.language }) , value: "1" }];
export const getYesNo = () => {return [true, false].map(x => { return { text: x } });}
export const getClientLongName = (client) => `${client.name} (${client?.currency?.shortName}) - ${client?.company?.name}`
//export const defaultActivitySort = (list) => {
//    return list?.slice()?.sort(fieldSorter(["project.client.name", "project.name", "code"])) ?? [];
//}

export const fieldSorter = (fields) => (a, b) => fields.map(o => {
    var nested = o.indexOf(".") > -1;
    let dir = 1;
    if (o[0] === '-') { dir = -1; o = o.substring(1); }
    return nested
        ? get(a,o) > get(b,o) ? dir : get(a,o) < get(b,o) ? -(dir) : 0
        : a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
}).reduce((p, n) => p ? p : n, 0);

export const get = (from, ...selectors) =>
    [...selectors].map(s =>
        s
            .replace(/\[([^\[\]]*)\]/g, '.$1.')
            .split('.')
            .filter(t => t !== '')
            .reduce((prev, cur) => prev && prev[cur], from)
);

/*export const MuiTruncatedText = observer((props) => {
    const maxLength = 50;
    return (
        <MuiTooltip>
            {props?.text?.length > maxLength ?
                <OverlayTrigger

                    placement={"top"}
                    overlay={<Tooltip>{props.text}</Tooltip>}>
                    <span>{trimElip(props.text, maxLength)}</span>
                </OverlayTrigger>
                : <span>{trimElip(props.text, maxLength)}</span>
            }
        </MuiTooltip>
    );
});*/

export const TruncatedText = observer((props) => {
    const maxLength = 50;
    return (
        <div>
            {props?.text?.length > maxLength ?
            <OverlayTrigger
                
                placement={"top"}
                overlay={<Tooltip>{props.text}</Tooltip>}>
                <span>{trimElip(props.text, maxLength)}</span>
            </OverlayTrigger>
            :<span>{trimElip(props.text, maxLength)}</span>
            }
        </div>
    );
});

export const trimElip = (value, length) => {
    return value?.length > length ? `${value.substring(0, length)?.trim()}...`: value;
}

export const getUniqueList = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()];
}

export const getFullName = (user) => `${user?.name} ${user?.surname}`

export const formatMonthYear = (currentDate) => {
    return currentDate ? `${currentDate.toLocaleString(getLocale(), { month: 'long' })} ${currentDate.toLocaleString(getLocale(), { year: 'numeric' })}` : "";
}

export const formatMonthYearNum = (currentDate) => {
    return currentDate ? `${currentDate.getMonth() + 1}_${currentDate.getFullYear()}` : "";
}

export const formatDateTime = (date) => {
    if (typeof date === 'string' || date instanceof String) { date = new Date(date) }
    return `${date?.toLocaleDateString("fr-CH")} ${date?.toLocaleTimeString("fr-CH")}`;
}

export const getRandomVal = () => {
    var v = parseFloat([8.00, 3.5, 4.00, 1.85, 7.00, ""][Math.floor(Math.random() * 6)]);
    return isNaN(v) ? "" : parseFloat(v).toFixed(2);
}

export const getDaysInCurrentMonth = (currentDate) => {
    if (currentDate) {
        const date = currentDate;

        return new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0
        ).getDate();
    } else {
        return 0;
    }
}

export const getTotalForCurrMonth = (dict, activity, currentDate) => { //GET BY ACTIVITY ID/ CURRENT MONTH/CURRENT YEAR
    if (!currentDate)
        return 0;

    //console.log(Object.entries(hours).filter(([k, v]) =>console.log(keyToProps(k))));
    if (Object.keys(dict)?.length) {

        var test = Object.entries(dict).filter(([k, v]) => keyToProps(k)?.activityId == activity.id && keyToProps(k)?.month == currentDate.getMonth() + 1 && keyToProps(k)?.year == currentDate.getFullYear());
        //console.log(test.map(x => x[1].value))
        //.map(x => x.value)        
        return test?.map(x => x[1]?.value ?? 0)?.reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2);
    } else {
        return 0;
    }
}

export const getTotalForCurrMonthDevExpense = (dict, activity, currentDate) => { 
    if (!currentDate)
        return 0;

    //console.log(Object.entries(hours).filter(([k, v]) =>console.log(keyToProps(k))));
    if (Object.keys(dict)?.length) {
        var test = dict.filter((value, index) => value.activityId == activity.id && value.month == currentDate.getMonth() + 1 && value.year == currentDate.getFullYear());        
        return test.map(x => x.billedExpenseAmount).reduce((partialSum, a) => partialSum + a, 0)?.toFixed(2);
    } else {
        return '';
    }
}

export const keyToProps = (key) => {    
    return { monthId: key.split("_")[0], hourId: key.split("_")[1], activityId: key.split("_")[2], day: key.split("_")[3], month: key.split("_")[4], year: key.split("_")[5] }
}

export const generateValueDict = (activities, role) => {
    console.log("generating values dictionary..")    
    var hours = {};
    activities?.forEach(a => {
        a.months?.forEach(m => {
            if (a.workUnit === 4) {                
                //Admin uses different property as the activities are not grouped
                //var sum = role === 1 ? (a?.billedExpenseAmount ?? 0) : getTotalForCurrMonthDevExpense(a.months, a, new Date(m.year, m.month - 1, 1));
                var hourId = "N";
                var key = propsToKey(m.id, hourId, a.id, 1, m.month, m.year);
                var value = 0; //Number(sum)                
                hours[key] = { defaultValue: value, value: value, temp: value, props: keyToProps(key) }                                
            }
            else if (a.workUnit === 3) {
                var monthHours = (m.hoursPerDay ?? [])?.map(x => x.hours).reduce((a, b) => a + b, 0);
                var hourId = m.hoursPerDay?.find(x => x.day === 1)?.id ?? "N";                
                var key = propsToKey(m.id, hourId, a.id, 1, m.month, m.year);
                hours[key] = { defaultValue: monthHours, value: monthHours, temp: monthHours, props: keyToProps(key) }
            }
            else {
                m.hoursPerDay.forEach(h => {
                    //if (a.workUnit == 3) { console.log(`isAmount for ${a.name} on ${m.month}/${m.year} - status:${m.status}: ${h.hours}`); }
                    var key = propsToKey(m.id, h.id, a.id, h.day, m.month, m.year);
                    hours[key] = { defaultValue: h.hours, value: h.hours, temp: h.hours, props: keyToProps(key) }
                })
            }
        })
    })    
    return hours;
}

export const propsToKey = (monthId, hourId, activityId, day, month, year) => {
    return `${monthId ?? "N"}_${hourId ?? "N"}_${activityId}_${day}_${month}_${year}`;
}

export const getLocale = () => {
    var locale = "en-us";
    switch (i18n.language) {
        case "en":
            locale = "en-us";
            break;
        case "fr":
            locale = "fr-ch"
            break;
    }
    return locale;
}

export const capitalize=(string)=> {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export const getDayNameFromDate = (currentDate) => {
    var locale = getLocale();            
    return capitalize(currentDate?.toLocaleDateString(locale, { weekday: 'long' })?.slice(0,3))
}
export const getDayName = (idx,currentDate) => {
    var locale = getLocale();
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), idx + 1);

    return date.toLocaleDateString(locale, { weekday: 'long' }).charAt(0)
}
export const isWeekend = (idx, currentDate) => {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), idx + 1);
    const day = date.getDay();

    return day === 6 || day === 0;
}

export const isWeekendByDate = (date) => {
    date = new Date(date);
    return date.getDay() === 6 || date.getDay() === 0;
}

export function useFirstRender() {
    const firstRender = useRef(true);

    useEffect(() => {
        firstRender.current = false;
    }, []);

    return firstRender.current;
}

export const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
export const asNum = (v) => {
    return isNumber(v) ? parseInt(v) : 0;
}

export const asFloat = (v) => {
    return isNumber(v) ? parseFloat(v) : 0;
}

export const getFirstOfMonth = (v) => {
    var date = moment(v, "yyyy-MM").toDate();    
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export const getLastOfMonth = (v) => {
    var date = moment(v, "yyyy-MM").toDate();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export const defaultPageSize = 12;

export const boolToYesNo = (v) => {
    return i18n.t(v ? "yes" : "no");
}

export const stripHTML = (v) => {
    return v.replace(/\&nbsp;/g, ' ').replace(/<br\s*[\/]?>/gi, ' ').replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "");
}

export const getUnits = (locale,billing) => {
    var units= [
        { id: 0, name: i18n.t("hour", { lng: locale ?? i18n.language}),key:"hour" },
        { id: 1, name: i18n.t("day", { lng: locale ?? i18n.language }) ,key:"day"},
        { id: 2, name: i18n.t("unit", { lng: locale ?? i18n.language }) ,key:"unit"},
        { id: 3, name: i18n.t("currencyAmount", { lng: locale ?? i18n.language }),key:"currencyAmount" }
    ];

    if (billing)
        units.push({ id: 4, name: i18n.t("expenseUnit", { lng: locale ?? i18n.language }), key: "expenseUnit" });
    return units;
}


export const getTemplateEvents = () => {
    return [
        { id: 0, name: i18n.t("timesheetSent"), },
        { id: 1, name: i18n.t("timesheetReject"), },
        { id: 2, name: i18n.t("emailFromAdministrator"), },
        { id: 3, name: i18n.t("recoverPassword") },
        { id: 4, name: i18n.t("invoice") },
        { id: 5, name: i18n.t("rejectInternalExpense") },
        /*{ id: 2, name: i18n.t("unit"), },
        { id: 3, name: i18n.t("currencyAmount"), }*/
    ];
}


/*export const getCurrencies = () => {
    return [
        { id: 0, name: "CHF" },
        { id: 1, name: "USD" },
        { id: 2, name: "EUR" },
        //{ id: 3, name: i18n.t("currencyAmount") }
    ];
}*/

export const getValueFromForm = (form, prop) => {
    if (form?.current) {
        const formData = Object.fromEntries(new FormData(form?.current).entries());
        //console.log(Object.fromEntries(new FormData(form?.current).entries()))
        console.log(formData);
        return formData[prop] ?? null;
        return null;
    } else {
        return null;
    }
}

export const removeSeparators = (value) => value?.toString()?.replaceAll("'", "");

export const prepareForm = (event, isNew, numberProps, numbersAsNull) => {    
    function isNumber(n) {
        //console.log(n+" is finite:" + isFinite(n));
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    const formData = Object.fromEntries(new FormData(event.target).entries());
    Object.keys(formData).forEach(e => {
        var asNull = numbersAsNull?.find(x => x == e);
        
        if (e == "id" && isNew) { formData[e] = 0 }        
        if (Array.isArray(numberProps) && numberProps.indexOf(e) > -1) { if (isNumber(removeSeparators(formData[e]))) { formData[e] = parseFloat(removeSeparators(formData[e])) } else { formData[e] = asNull ? null : 0 } }
        if (formData[e] == "on") { formData[e] = true; }
        else if (formData[e] == "off") { formData[e] = false; }
    });
    return formData;
};

export const currentUserId = () => {
    try {
        const user = JSON.parse(window.localStorage.getItem('loginStore'));
        return parseJWT(user?.accountInfo?.token)?.["usr"];        
    } catch {
        return null;
    }
}
export const parseJWT = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const getUserType = (val) => {    
    var type = "";
    switch (val) {
        case 1:
            type = i18n.t('admin')
            break;
        case 2:
            type = i18n.t('client')
            break;
        case 3:
            type = i18n.t('consultant')
            break;
        default:
            type = "-";
            break;
    }
    return type;
}

export const twoDecimalFormatter = (v) => {
    return Number(v).toFixed(2).replace(",",".");
}

export const winbizFormatter = (val) => {
    if (!val) { return ""; }

    var cleaned = ('' + val).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{0,4})(\d{0,4})(\d{0,1})$/);
    if (match?.[1]?.length > 0 || match?.[2]?.length > 0) {

        var f = `${match[1]}${match[2]?.length > 0 ? "-" : ""}${match[2]}`;
        return f;//.substring(0, 9);
    } else {
        return "";
    }
    /*else if (/^([A-Za-z]{0,5})$/g.test(val)) {
        var f = val.replace(/^([A-Za-z]{0,4})$/g, "$1");
        return f.substring(0, 4);
    }*/
    /*else {
        return val;
    }*/
}

export const winbizValidator = (val) => {
    if (!val) { return false; }
    var isValid = val.match(/^(\d{4})-(\d{4})$/) || val.match(/^(\d{4})$/);    
    return isValid  /*|| (/^([A-Za-z]{4})$/g.test(val))*/ ? true : false;
}

export const twoDecimalValidator = (val) => {
    if (!val) { return false; }
    var isValid = val?.toString()?.match(/^(\d+(?:,\d{1,2})?).*/);
    return isValid  /*|| (/^([A-Za-z]{4})$/g.test(val))*/ ? true : false;
}